// extracted by mini-css-extract-plugin
export var chevronIcon = "_ct-2";
export var teamName = "_ct-1";
export var teamSwitcherButton = "_ct-0";